const primary = {
    black: '#2E2F33',
    blackDark: '#111113',
};
const semantic = {
    positive120: '#056B42',
    positive100: '#1BAB5D',
    positive70: '#1ADB81',
    positive30: '#74E6AD',
    positive10: '#E8FCF1',
    critical120: '#BB2532',
    critical100: '#E8313A',
    critical70: '#F64C56',
    critical30: '#FF8993',
    critical10: '#FFD1DA',
    warning120: '#A57412',
    warning100: '#FBB104',
    warning70: '#FCC736',
    warning30: '#FDDC72',
    warning10: '#FFF2CC',
    link120: '#104D93',
    link100: '#1268ED',
    link70: '#4C8AF6',
    link30: '#B1CFFB',
    link10: '#E7EEFE',
};
const neutral = {
    grey150: '#36363A',
    grey100: '#6D7176',
    grey70: '#A1A2A8',
    grey30: '#D7D8DA',
    grey10: '#EAEBEB',
    grey05: '#F2F2F3',
    grey01: '#F7F7F8',
    grey00: '#FFFFFF',
};
const secondary = {
    purple120: '#7A05B1',
    purple100: '#A31AE3',
    purple70: '#C876EF',
    purple30: '#DBA3F4',
    purple10: '#FCDDFD',
    //
    purpleBlue120: '#4E2AD9',
    purpleBlue100: '#7551FF',
    purpleBlue70: '#9E84FF',
    purpleBlue30: '#C6B8FF',
    purpleBlue10: '#EBE5FF',
    //
    teal120: '#007474',
    teal100: '#039C9C',
    teal70: '#04CDCD',
    teal30: '#89E8E8',
    teal10: '#D7FEFE',
    //
    pink120: '#CC3683',
    pink100: '#EF5DA8',
    pink70: '#F38BC1',
    pink30: '#F8B9DA',
    pink10: '#FDE8F2',
    //
    lightBlue120: '#0282CA',
    lightBlue100: '#39B8FF',
    lightBlue70: '#6BCAFF',
    lightBlue30: '#9EDCFF',
    lightBlue10: '#E5F6FF',
    //
    coral120: '#E24639',
    coral100: '#FF6F63',
    coral70: '#FF9A92',
    coral30: '#FFD4D0',
    coral10: '#FFF1EF',
    //
    green120: '#36AC4A',
    green100: '#74D585',
    green70: '#8BEF9D',
    green30: '#CEF9D5',
    green10: '#EFFDF1',
    //
    yellow120: '#DAA71A',
    yellow100: '#F4C954',
    yellow70: '#F7D987',
    yellow30: '#FBEFCC',
    yellow10: '#FEFAEE',
};
export { primary, semantic, neutral, secondary };
